import React, { useState } from 'react';
import { get_api_url } from '../../../../utils/urls';
import { post_api } from '../../../../redux/api_funcs';
import { PlatformAccessPackagePlan } from '../../../../constants/index';

interface PlatformAccessDowngradeProps {
  onClose: () => void;
  student_plan_uuid: string;
  loadStudentData: () => void;
  student_current_plan: string;
  is_prepaid: number;
  is_subscribed: number;
  no_of_weeks_originally_enrolled_to: number;
  no_of_cycle_remaining: number;
  set_notification_variable: (show: boolean, type: string, message: string) => void;
}

function PlatformAccessDowngrade({
  onClose,
  loadStudentData,
  student_current_plan,
  is_prepaid,
  no_of_weeks_originally_enrolled_to,
  no_of_cycle_remaining,
  set_notification_variable
}: PlatformAccessDowngradeProps) {
  const [errorMessage, setErrorMessage] = useState('');
  const [reasonForDowngrade, setReasonForDowngrade] = useState('');

  const handleSubmit = async () => {
    const id = new URLSearchParams(window.location.search).get('id');
    const apiUrl = get_api_url('membership_downgrade');
    const payload = {
      student_uuid: id,
      downgrade_package_uuid: PlatformAccessPackagePlan[0].value, // Platform Access package UUID,
      no_of_weeks: 4,
      reason: reasonForDowngrade
    };

    try {
      const response = await post_api(apiUrl, payload, true);
      if (response.data.status === 'success') {
        set_notification_variable(
          true,
          'success',
          'Schedule Downgrade Successful to Platform Access'
        );
        loadStudentData();
        onClose();
      }
    } catch (error) {
      console.log('error', error.response);
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        'Something went wrong. Please try again.';
      setErrorMessage(msg);
    }
  };

  return (
    <div className="w-[430px]">
      <hr className="border-t border-gray-300 mb-5" />

      <div className="mb-3">
        <b>Current Plan:</b> <span>{student_current_plan}</span>
        <span>{is_prepaid === 0 ? `/Monthly` : null}</span>
      </div>

      {is_prepaid === 1 && (
        <>
          <div className="mb-3">
            <b>No. of weeks enrolled to:</b> <span>{no_of_weeks_originally_enrolled_to}</span>
          </div>

          <div className="mb-3">
            <b>No. of billing cycles left:</b>
            <span>{no_of_cycle_remaining}</span>
          </div>
        </>
      )}

      <div className="mb-3">
        <label className="block text-sm text-gray-700 mb-1 font-semibold">
          Target package plan:
        </label>
        <div className="border border-gray-300 rounded-md p-2 text-sm bg-gray-50">
          Platform Access
        </div>
      </div>

      <div className="mb-3">
        <label
          className="block text-sm text-gray-700 mb-1 mt-6 font-semibold"
          style={{ textTransform: 'unset' }}
        >
          Reason For Downgrade <span className="text-[red]">*</span>
        </label>
        <textarea
          className="h-[80px] border border-gray-300 rounded-md w-full p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={reasonForDowngrade}
          onChange={(e) => setReasonForDowngrade(e.target.value)}
          placeholder="Enter the reason for the Downgrade..."
        />
      </div>

      <div className="bg-yellow-100 border border-[#ffef8a] rounded-[8px] p-3 mb-5 text-sm text-yellow-900">
        <strong>Warning:</strong> This action will schedule membership downgrade for student to
        platform access plan.
      </div>

      <div className="bg-blue-100 border border-[#bfdbfe] rounded-[8px] p-3 mb-5 text-[#1c4ed8] text-sm">
        <strong>Note:</strong> Student will be charged $19 in their next renewal billing cycle
      </div>

      {errorMessage && (
        <div className="bg-red-100 text-red-800 p-3 mb-5 mt-5 rounded">
          <strong>Error:</strong> {errorMessage}
        </div>
      )}

      <div className="flex justify-center gap-4">
        <button
          onClick={onClose}
          className="bg-gray-200 text-black px-6 py-2 w-full rounded border border-gray-400 hover:bg-gray-300"
        >
          Cancel
        </button>

        <button
          onClick={handleSubmit}
          disabled={!reasonForDowngrade}
          className={`px-6 py-2 w-full rounded border text-white 
            ${
              !reasonForDowngrade
                ? 'bg-red-600 border-red-700 opacity-60 cursor-not-allowed'
                : 'bg-red-600 border-red-700 hover:bg-red-700 cursor-pointer'
            }`}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default PlatformAccessDowngrade;
